import { Result, DeleteData } from 'domain/types';

import DeleteLinkClient from 'use-case/link/delete/deleteLinkClient';
import DeleteLinkCriteria from 'use-case/link/delete/deleteLinkCriteria';

export type DeleteLinkResult = Result<DeleteData>;
export type DeleteLink = (criteria: DeleteLinkCriteria) => Promise<DeleteLinkResult>;

export default (deleteLinkClient: DeleteLinkClient): DeleteLink => (criteria: DeleteLinkCriteria): Promise<DeleteLinkResult> =>
    deleteLinkClient(criteria);
